exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert[data-v-4df489dc]{width:30%;background-color:rgba(0,0,0,.7);text-align:center;font-weight:700;color:#fff;position:fixed;bottom:0;left:50%;transform:translateX(-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4df489dc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Toast.vue
// module id = 358
// module chunks = 0